import React from "react";
import { Padding, Sheet, Layout, Text } from "@kidslivesafe/sc-react";
import "./protection.css";

interface ProtectionShellProps {
  title: string;
  subtitle?: string;
  subtitleColor?:
    | "base"
    | "primary"
    | "white"
    | "subtle"
    | "error"
    | "accent"
    | "dark-gray"
    | "success"
    | "monitoring"
    | "neighborPin"
    | "clickable";
  stepLabel?: string;
  children: React.ReactNode;
}

const ProtectionShell: React.FC<ProtectionShellProps> = ({
  title,
  subtitle,
  subtitleColor,
  stepLabel,
  children,
}) => {
  return (
    <>
      <Sheet>
        <Padding space="md">
          <Layout
            type="flex"
            flexProps={{ direction: "column", gap: "sm", alignItems: "center" }}
          >
            <Layout type="flex" flexProps={{ direction: "column", gap: "sm" }}>
              {stepLabel ? (
                <Text size="xs" fontWeight="semibold">
                  {stepLabel}
                </Text>
              ) : null}
              <Text tag="h2" fontWeight="bold">
                {title}
              </Text>
              {subtitle ? (
                <Text size="sm" color={subtitleColor}>
                  {subtitle}
                </Text>
              ) : null}
              {children}
            </Layout>
          </Layout>
        </Padding>
      </Sheet>
    </>
  );
};

export default ProtectionShell;
